import React from 'react';
import Loader from 'react-loader-spinner';
import common from 'constants/common';

const withLoader = (loading, Component) => {
  if (loading) {
    return <Loader className="loader" type="Oval" color={common.loaderColor} />;
  }
  return Component;
};

export default withLoader;
